export const defaultResellerOptions = [
  { value: "Exclusive", label: "Exclusive", description: "Qualified resellers in the Exclusive package" },
  { value: "E-Commerce", label: "E-Commerce", description: "Qualified resellers in the E-Commerce package" },
  { value: "Commercial", label: "Commercial", description: "Qualified resellers in the Commercial package" },
  { value: "Academy", label: "Academy", description: "Qualified Academy resellers in the Buying Group package" },
  { value: "Novexco", label: "Novexco", description: "Qualified Novexco resellers in the Buying Group package" },
  { value: "COOPSCO", label: "COOPSCO", description: "Qualified COOPSCO resellers in the Buying Group package" },
  { value: "Cantrex", label: "Cantrex", description: "Qualified Cantrex resellers in the Buying Group package" },
  { value: "Jean Coutu", label: "Jean Coutu", description: "Qualified Jean Coutu resellers in the Buying Group package" },
  { value: "Starter", label: "Starter", description: "Qualified resellers in the Starter package" },
  { value: "Campus Store", label: "Campus Stores Canada", description: "Campus Stores Canada resellers" },
] as const;

export const buildCommaSeparatedValue = (tokens: readonly string[]) => tokens.map((token) => `${token},`).join("");

export const toggleCommaSeparatedValue = (currentValue: string, token: string) => {
  const normalized = currentValue || "";
  if (normalized.includes(`${token},`)) {
    return normalized.replaceAll(`${token},`, "");
  }
  return `${normalized}${token},`;
};
